import { getApp } from 'firebase/app';
import {
  getFirestore,
  initializeFirestore,
  type Firestore,
} from 'firebase/firestore';

export function createFirestore(
  useEmulator: boolean,
  emulatorPort = 8080
): Firestore {
  if (!useEmulator) {
    return getFirestore();
  }

  return initializeFirestore(getApp(), {
    experimentalForceLongPolling: true,
    host: `127.0.0.1:${emulatorPort}`,
    ssl: false,
  });
}
